<template>
  <main class="container d-flex justify-content-center">
    <div class="article">
      <div class="return-url">
        <a
          href="https://www.justis.nl/producten/naamswijziging/achternaam-minderjarige-wijzigen/index.aspx"
          >Terug naar: Achternaam minderjarige wijzigen</a
        >
      </div>

      <h1>
        <strong
          >Kan ik de achternaam van mijn minderjarige kind wijzigen in mijn
          eigen achternaam?</strong
        >
      </h1>
      <p>
        De onderstaande rekentool helpt u vast te stellen of naamswijziging in
        uw situatie tot de mogelijkheden behoort. De tool geeft de
        verzorgingstermijn weer en berekent de periode waarin u met de andere
        ouder gezamenlijk in gezinsverband heeft geleefd (bij kinderen onder de
        12 jaar). Beide termijnen zijn bepalend voor de uitkomst van een verzoek
        tot naamswijziging van een kind.
      </p>
      <p>
        Let op: de uitkomst van de berekening geeft alleen een indicatie, op
        basis van de door u ingevulde gegevens. Hieraan kunnen geen rechten
        worden ontleend.
      </p>

      <div class="errors">
        <div v-for="(error, i) in errors" :key="i">
          <img class="icon" src="../assets/icons/kruis.svg" />
          {{ error }}
        </div>
      </div>

      <form v-on:submit.prevent autocomplete="off">
        <div class="mandatory"><small>*Verplicht veld</small></div>
        <div class="form-box" v-bind:class="{ error: errors[0] }">
          <div class="input-container">
            <label for="datum_aanvraag">Datum Aanvraag *</label>
            <span class="date-wrapper" v-on:click="focus('datum_aanvraag')">
              <datepicker
                id="datum_aanvraag"
                :value.sync="form.datum_aanvraag"
                v-once
              ></datepicker>
            </span>
          </div>
          <div
            class="info-container"
            v-on:click="openModal('modal_datum_aanvraag')"
          >
            <img class="icon info-icon" src="../assets/icons/info.svg" />
            <small>Toelichting</small>
          </div>
        </div>

        <div class="form-box" v-bind:class="{ error: errors[1] }">
          <div class="input-container">
            <label for="geboortedatum">Geboortedatum kind *</label>
            <span class="date-wrapper" v-on:click="focus('geboortedatum')">
              <datepicker
                id="geboortedatum"
                :value.sync="form.geboortedatum"
                v-once
              ></datepicker>
            </span>
          </div>
          <div
            class="info-container"
            v-on:click="openModal('modal_geboortedatum')"
          >
            <img class="icon info-icon" src="../assets/icons/info.svg" />
            <small>Toelichting</small>
          </div>
        </div>

        <div class="form-box" v-bind:class="{ error: errors[2] }">
          <div class="input-container">
            <label for="datum_aanvang"
              >Datum <strong>aanvang</strong> gezamenlijke opvoeding door ouders
              *</label
            >
            <span class="date-wrapper" v-on:click="focus('datum_aanvang')">
              <datepicker
                id="datum_aanvang"
                :value.sync="form.datum_aanvang"
                v-once
              ></datepicker>
            </span>
          </div>
          <div
            class="info-container"
            v-on:click="openModal('modal_datum_aanvang')"
          >
            <img class="icon info-icon" src="../assets/icons/info.svg" />
            <small>Toelichting</small>
          </div>
        </div>

        <div class="form-box" v-bind:class="{ error: errors[3] }">
          <div class="input-container">
            <label for="datum_einde"
              >Datum <strong>einde</strong> gezamenlijke opvoeding door ouders
              *</label
            >
            <span class="date-wrapper" v-on:click="focus('datum_einde')">
              <datepicker
                id="datum_einde"
                :value.sync="form.datum_einde"
                v-once
              ></datepicker>
            </span>
          </div>
          <div
            class="info-container"
            v-on:click="openModal('modal_datum_einde')"
          >
            <img class="icon info-icon" src="../assets/icons/info.svg" />
            <small>Toelichting</small>
          </div>
        </div>

        <div class="button-container">
          De Bereken-knop wordt automatisch actief nadat u alle vragen hebt
          beantwoord
          <b-btn
            tabindex="0"
            class="submit-button"
            v-bind:class="{ disabled: !valid }"
            to="/result"
            >Bereken</b-btn
          >
        </div>
      </form>

      <disclaimer></disclaimer>
    </div>

    <div>
      <ui-modal
        ref="modal_datum_aanvraag"
        title="Datum Aanvraag"
        removeCloseButton
      >
        Datum waarop de aanvraag wordt ingediend.
        <div slot="footer">
          <ui-button @click="closeModal('modal_datum_aanvraag')"
            >Sluit</ui-button
          >
        </div>
      </ui-modal>
      <ui-modal
        ref="modal_geboortedatum"
        title="Geboortedatum kind"
        removeCloseButton
      >
        Geboortedatum van kind wiens naam wijzigt.
        <div slot="footer">
          <ui-button @click="closeModal('modal_geboortedatum')"
            >Sluit</ui-button
          >
        </div>
      </ui-modal>
      <ui-modal
        ref="modal_datum_aanvang"
        title="Datum aanvang gezamenlijke opvoeding door ouders"
        removeCloseButton
      >
        Dit is de geboortedatum van het kind, tenzij de gezamenlijke opvoeding
        door de ouders later is gestart.
        <div slot="footer">
          <ui-button @click="closeModal('modal_datum_aanvang')"
            >Sluit</ui-button
          >
        </div>
      </ui-modal>
      <ui-modal
        ref="modal_datum_einde"
        title="Datum einde gezamenlijke opvoeding door ouders"
        removeCloseButton
      >
        Dit is de datum waarop de echtscheiding is ingeschreven in de
        Basisregistratie Personen, of de datum dat de buitenhuwelijkse
        samenleving is verbroken volgens de Basisregistratie Personen.
        <div slot="footer">
          <ui-button @click="closeModal('modal_datum_einde')">Sluit</ui-button>
        </div>
      </ui-modal>
    </div>
  </main>
</template>

<script>
import Vue from "vue";
import { UiModal, UiButton } from "keen-ui";
import state from "../state.js";
import datepicker from "../components/datepicker";
import disclaimer from "../components/disclaimer.vue";
var moment = require("moment");

export default {
  components: {
    datepicker,
    UiModal,
    UiButton,
    disclaimer
  },
  data() {
    return {
      form: state.form
    };
  },
  beforeRouteLeave(to, from, next) {
    return next(this.valid);
  },
  methods: {
    focus(id) {
      document.getElementById(id).focus();
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    }
  },
  computed: {
    errors() {
      let errors = {};
      Object.keys(this.form).forEach((k, i) => {
        let regex = /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/;
        if (
          this.form[k] !== null &&
          this.form[k] !== "" &&
          !regex.test(this.form[k])
        ) {
          errors[i] = "U dient de datum in het formaat dd-mm-jjjj in te vullen";
          return;
        }
        if (k === "geboortedatum") {
          let now = moment();
          let geboortedatum = moment(this.form["geboortedatum"], "DD-MM-YYYY");
          if (geboortedatum.isAfter(now, "days")) {
            errors[i] = "De geboortedatum mag niet in de toekomst liggen";
          }
        }
        if (k === "datum_aanvang") {
          let datum_aanvang = moment(this.form["datum_aanvang"], "DD-MM-YYYY");
          let geboortedatum = moment(this.form["geboortedatum"], "DD-MM-YYYY");
          if (datum_aanvang.isBefore(geboortedatum, "days")) {
            errors[i] = "De datum mag niet eerder dan de geboortedatum zijn";
          }
        }
        if (k === "datum_einde") {
          let datum_aanvang = moment(
            this.form[("datum_aanvang", "DD-MM-YYYY")]
          );
          let datum_einde = moment(this.form[("datum_einde", "DD-MM-YYYY")]);
          if (datum_einde.isBefore(datum_aanvang, "days")) {
            errors[i] =
              "De datum mag niet eerder dan de datum aanvang gezamenlijke opvoeding zijn";
          }
        }
      });

      return errors;
    },
    valid() {
      var valid = true;

      Object.keys(this.errors).forEach((k, i) => {
        valid = false;
      });

      Object.keys(this.form).forEach((k, i) => {
        if (this.form[k] === null || this.form[k] === "") {
          valid = false;
        }
      });

      return valid;
    },
    isPhone() {
      let width = window.screen.width;
      let height = window.screen.height;
      let min = Math.min(width, height);
      return min < 480;
    }
  }
};
</script>

<style lang="scss">
@import "../_common.scss";

.article {
  margin-bottom: 100px;
}

.date-wrapper input {
  margin: 0px;
  padding: 0px 15px;
  height: 32px;
  width: 130px;
  background-color: white;
  border: none;
  border-bottom: 2px solid dji-color(paars, 1);
  :focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
  }
}

.date-wrapper {
  cursor: pointer;
}

.form-box {
  display: flex;
  padding: 12px 15px 12px 20px;
  margin: 0px 0px 0px -20px;
  background: dji-color(paars, 3);
  justify-content: space-between;
}

.errors {
  margin: 20px 0px;
  color: dji-color(rood);
}

.mandatory {
  text-align: right;
  margin-right: 5px;
}

.error {
  background: dji-color(rood, 2);
}

.info-container {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  cursor: pointer;
}

.info-icon {
  width: 2em;
  height: 2em;
  align-self: center;
}

.ui-modal__header {
  background-color: white;
  box-shadow: none;
}

.ui-modal__mask {
  height: 100vh;
}

label {
  display: block;
}

.button-container {
  text-align: right;
  padding: 10px 0px 0px 35px;
  font-size: 0.75rem;
  color: gray;
}

.submit-button {
  background-color: dji-color(paars, 1);
  color: white;
  border: none;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
  margin: 0px 5px 0px 15px;
  padding: 10px 50px;
  &:hover {
    text-decoration: none;
    color: white;
    border-color: transparent;
    background: #33104a;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/form.vue